import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../config';

const DEFAULTS = {
  instance_name: window.__CONFIG__?.INSTANCE_NAME || 'Dolmio',
  instance_tagline: 'Auftragsverwaltung für Dolmetschagenturen',
  instance_domain: 'dolmio.org',
  primary_color: window.__CONFIG__?.INSTANCE_PRIMARY_COLOR || '#00498a',
  secondary_color: window.__CONFIG__?.INSTANCE_SECONDARY_COLOR || '#d51130',
  company_name: window.__CONFIG__?.INSTANCE_COMPANY_NAME || '',
  support_email: window.__CONFIG__?.INSTANCE_SUPPORT_EMAIL || '',
  features: [],
  version: null,
  loaded: false,
};

const BrandingContext = createContext(DEFAULTS);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  useEffect(() => {
    fetch(`${API_URL}/api/branding`)
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(data => setBranding({ ...data, loaded: true }))
      .catch(() => setBranding(prev => ({ ...prev, loaded: true })));
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

export function useFeatureFlag(name) {
  const { features, loaded } = useBranding();
  // Before branding loads, assume all features enabled (backward compatible)
  if (!loaded || features.length === 0) return true;
  return features.includes(name);
}
